var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full flex items-center gap-[2px]"},_vm._l((10),function(index){return _c('div',{key:index,staticClass:"w-full h-[6px]",class:[index <= _vm.volumeLevel ? 'bg-[#6AD76A]' : 'bg-[#D9D9D9]']})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }